import { useEffect, useMemo, useState } from 'react';
import { Widget } from '@typeform/embed-react'

import { ContentModalKlaviyoForm } from './ContentModalKlaviyoForm';
import { ContentModalPostscriptForm } from './ContentModalPostscriptForm';

export function ContentModal({
  content,
  linkText = '',
}) {
  const [email, setEmail] = useState('');
  const [responseStatusKlaviyo, setResponseStatusKlaviyo] = useState('');
  const [responseStatusPostscript, setResponseStatusPostscript] = useState('');
  const [showKlaviyo, setShowKlaviyo] = useState(true);
  const [fadeKlaviyo, setFadeKlaviyo] = useState(false);
  const [showPostscript, setShowPostscript] = useState(false);
  const [fadePostscript, setFadePostscript] = useState(false);

  useEffect(() => {
    if (responseStatusKlaviyo === 'success') {
      setTimeout(() => {
        setFadeKlaviyo(true);
        setTimeout(() => {
          setShowKlaviyo(false);
          setShowPostscript(true);
          setTimeout(() => setFadePostscript(true), 10); // allow mount before fade in
        }, 1000); // match fade duration
      }, 1000); // 2s delay before fade out
    }
  }, [responseStatusKlaviyo]);

  // Memoize only the HTML rendering
  const htmlMarkup = useMemo(() => {
    if (!content?.html) return null;
    return (
      <div
        className="mx-auto flex flex-col [&>:first-child]:mt-0 [&>:last-child]:mb-0 [&_a]:underline [&_h1]:mb-6 [&_h2]:mb-5 [&_h2]:mt-8 [&_h3]:mb-4 [&_h3]:mt-6 [&_h4]:mb-4 [&_h4]:mt-4 [&_h5]:mb-4 [&_h5]:mt-2 [&_h6]:mb-4 [&_li>p]:mb-0 [&_li]:mb-2 [&_ol>li]:list-decimal [&_ol]:mb-4 [&_ol]:pl-8 [&_p]:mb-4 [&_ul>li]:list-disc [&_ul]:mb-4 [&_ul]:pl-8"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: content.html }}
      />
    );
  }, [content?.html]);

  return (
    <div className="h-full w-full">
      {content?.heading && (
        <h2 className="text-title-h3 text-center">{content.heading}</h2>
      )}
      {content?.text && <p className="text-center">{content.text}</p>}
      {htmlMarkup}
      {content?.typeformId && (
        <Widget
          id={content?.typeformId}
          style={{ width: '100%', height: '100%' }}
          className="my-form"
        />
      )}
      {content?.klaviyoForm?.listId && showKlaviyo && (
        <div className={`transition-opacity duration-1000 ${fadeKlaviyo ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
          <ContentModalKlaviyoForm
            klaviyoForm={content?.klaviyoForm}
            linkText={linkText}
            email={email}
            setEmail={setEmail}
            responseStatus={responseStatusKlaviyo}
            setResponseStatus={setResponseStatusKlaviyo}
          />
        </div>
      )}
      {showPostscript && content?.postscriptForm?.keywordId && (
        <div className={`transition-opacity duration-1000 ${fadePostscript ? 'opacity-100' : 'opacity-0'}`}>
          <ContentModalPostscriptForm
            postscriptForm={content?.postscriptForm}
            linkText={linkText}
            email={email}
            responseStatus={responseStatusPostscript}
            setResponseStatus={setResponseStatusPostscript}
          />
        </div>
      )}
    </div>
  );
}